import { tss } from 'tss-react';

export const useStyles = tss.create({
  supportMessage: {
    marginTop: 25,
    fontWeight: 500,
    fontSize: 12
  }
});

export const useSx = ({ blue }) => ({
  textDecoration: 'underline !important',
  cursor: 'pointer',
  ...(blue && {
    color: 'var(--light-blue) !important'
  })
});
